<template>
  <div style="position:relative">
    <!-- 일정 선택 -->
    <div class="color-sub size-12" style="margin:12px 0 4px 0">일정</div>
    <div :style="inputDateStyle"
         @click="clickSchedule">{{ dateText }}<span v-if="timeText!==''" class="size-12"><br>{{ timeText }}</span></div>
    <!-- 수량 -->
    <div v-if="!option1 && !option2">
      <div class="color-sub size-12" style="margin:12px 0 4px 0">수량</div>
      <quantity-input-popup :value.sync="order.ordered_count"
                            :numberStyle="numberStyle"></quantity-input-popup>
    </div>
    <!-- 옵션 사용 -->
    <div style="margin-top:20px" v-if="option1">
      <div class="color-sub size-12" style="margin:12px 0 4px 0">필수 선택 옵션</div>
      <lp-dropdown :options="option1.options"
                   placeholder="필수 선택 옵션"
                   :ele.sync="option1.value"></lp-dropdown>

      <div v-if="option2">
        <div class="color-sub size-12" style="margin:12px 0 4px 0">추가 옵션</div>
        <lp-dropdown v-if="option2"
                     :options="option2.options"
                     placeholder="추가 옵션"
                     :ele.sync="option2.value"></lp-dropdown>
      </div>

      <!-- 선택 된 옵션 수량 -->
      <!-- 필수 옵션 수량 -->
      <div class="grid-box" v-if="option1 && option1.value"
           :style="optQuantityStyle" style="margin-top:20px">
        <div class="col-8">
          <div class="size-12" style="margin-bottom:8px">{{ option1.value.label }}</div>
          <quantity-input-popup
            :inputStyle="{padding: 0, width: '100px'}"
            :min="option1.minimum"
            :max="option1.maximum"
            :value.sync="option1.value.quantity"></quantity-input-popup>
        </div>
        <div class="col-4 flex-end">
          <div class="size-16" style="font-weight:600">{{ `${ option1.value.price * option1.value.quantity }`|currency }}</div>
          <i class="material-icons unselect" @click="option1.value = undefined"
             :style="closeStyle">close</i>
        </div>
      </div>
      <!-- 추가 옵션 수량 -->
      <div class="grid-box" v-if="option2 && option2.value"
           :style="optQuantityStyle" style="margin-top:8px">
        <div class="col-8">
          <div class="size-12" style="margin-bottom:8px">{{ option2.value.label }}</div>
          <quantity-input-popup
            :inputStyle="{padding: 0, width: '100px'}"
            :min="option2.minimum"
            :max="option2.maximum"
            :value.sync="option2.value.quantity"></quantity-input-popup>
        </div>
        <div class="col-4 flex-end">
          <div class="size-16" style="font-weight:600">{{ `${ option2.value.price * option2.value.quantity }`|currency }}</div>
          <i class="material-icons unselect" @click="option2.value = undefined"
             :style="closeStyle">close</i>
        </div>
      </div>

    </div>

    <!-- 하단 플로팅 버튼 -->
    <div class="flex-end" style="margin-top:40px" v-if="btnEnable">
      <button class="button" @click="clickAccount">선택하기</button>
    </div>

    <!-- 캘린더 -->
    <div style="position:absolute;top:-12px;background-color: white;z-index: 10">
      <component :is="scheduleComponent" :productId="product.id"
                 v-show="vSchedule" @selectedResv="onSelectResv" />
    </div>
  </div>
</template>
<script>

  import LpDropdown from "@/components/module/common/LpDropdown";
  import QuantityInputPopup from "@/components/module/common/QuantityInputPopup";
  import ScheduleOverlay from "./ScheduleOverlay";
  import SchedulePeriodOverlay from "./SchedulePeriodOverlay";
  export default {
    name: 'BlockResvOption',
    components: {
      SchedulePeriodOverlay,
      ScheduleOverlay,
      QuantityInputPopup,
      LpDropdown
    },
    mixins: [

    ],
    props: {
      product: {
        type: Object,
      },

    },
    data() {
      return {
        order: {
          ordered_count: 1
        },
        option1: undefined,
        option2: undefined,
        selectedResv: undefined,
        vSchedule: false
      }
    },
    created() {
      let opt = this.product.selectors.filter(item => { return item.option_type === 0});
      if(opt.length>0) {
        this.option1 = this.setOption(opt[0]);
      }
      opt = this.product.selectors.filter(item => { return item.option_type === 1});
      if(opt.length>0) {
        this.option2 = this.setOption(opt[0]);
      }
    },
    mounted() {

    },

    methods: {
      onSelectResv(res) {
        this.selectedResv = res;
        this.vSchedule = false;
      },
      clickAccount() {
        if(!this.btnEnable) return;
        let resv = this.selectedResv;
        resv.ordered_count = this.order.ordered_count;
        resv.option1 = this.option1;
        resv.option2 = this.option2;
        let param = {};
        // 숙박 예약(기간)
        if(resv.period) {
          param = resv;
          param.product_id = this.product.id;
          if(resv.resv_date !== resv.resv_end_date) {
            param.resvStr = `${resv.resv_date} ~ ${resv.resv_end_date}`;
          } else {
            param.resvStr = resv.resv_date;
          }

        } else {
          // 서비스 예약(단일 시간/날짜)
          let time = '';
          if(resv.all_time) {
            time = '종일';
          } else {
            time = `${resv.start_time} ~ ${resv.end_time}`;
          }
          param = {
            ordered_count: resv.ordered_count,
            date: resv.org_start_date,
            time: time,
            all_time: resv.all_time,
            start_time: resv.start_time,
            end_time: resv.end_time,
            product_id: this.product.id
          };
          param.resvStr = `${resv.org_start_date} (${time}) `;
        }
        let opt1 = '';
        if(resv.option1 && resv.option1.value) {
          let val = resv.option1.value;
          opt1 = `${val.name} x ${val.quantity}`;
        }
        let opt2 = '';
        if(resv.option2 && resv.option2.value) {
          let val = resv.option2.value;
          opt2= `${val.name} x ${val.quantity}`;
        }
        if(opt1 !== '' && opt2 !== '') {
          param.resvStr += `(${opt1}, ${opt2})`;
        } else if(opt1 !== '') {
          param.resvStr += `(${opt1})`;
        } else if(opt2 !== '') {
          param.resvStr += `(${opt2})`;
        }

        // 옵션 없을 때
        if(!this.option1 && !this.option2) {
          param.ordered_count = this.order.ordered_count;
        } else {
          if(this.option1)
            param.option1 = this.option1;
          if(this.option2)
            param.option2 = this.option2;
        }

        // 금액 적용
        param.order_price = this.calcPrice;
        param.discount_price = this.discountPrice;

        this.$emit('clickReserve', param);
      },
      clickSchedule() {
        this.vSchedule = true;
      },
      updateValue(res, opt) {
        opt.value = this.cloneItem(res);
      },
      setOption(opt) {
        let option = {
          name: opt.name,
          minimum: opt.minimum,
          maximum: opt.maximum,
          value: undefined,
          options: []
        };
        opt.options.forEach(item=>{
          item.label = `${item.name}: +${this.currency(item.price)}`;
          item.quantity = opt.minimum;
          option.options.push({
            value: item,
            label: item.label
          });
        });
        return option;
      }
    },
    computed: {
      scheduleComponent() {
        return this.product.order_conversion_type === 10 ? 'ScheduleOverlay' : 'SchedulePeriodOverlay';
      },
      btnEnable() {
        let enable = this.selectedResv !== undefined;
        if(this.option1) {
          enable = this.option1.value !== undefined;
        }
        return enable;
      },
      btnStyle() {
        let deco = {
          color: {color: '#99999'},
          bg: { backgroundColor: '#eeeeee' }
        };
        if(this.btnEnable) {
          deco = {
            color: {color: '#ffffff'},
            bg: {backgroundColor: '#ff5722'}
          }
        }

        return deco;
      },
      calcPrice() {
        let price = this.product.price.price;
        let resv = this.selectedResv;
        if(resv===undefined) {
          return price;
        }
        // 종일 시간대 상품 가격
        if(resv.all_time && this.product.price.all_time) {
          price = this.product.price.all_time_price;
        }

        // 할인 있을 경우 반영
        price -= this.discountPrice;

        // 상품 옵션가 반영
        if(this.option1 && this.option1.value) {
          price = (price + this.option1.value.price) * this.option1.value.quantity;
        }
        if(this.option2 && this.option2.value) {
          price += this.option2.value.price * this.option2.value.quantity;
        }
        // 상품 옵션 없는 경우 수량 반영
        if(!this.option1 && !this.option2) {
          price *= this.order.ordered_count;
        }

        // 기간이 있을 경우
        if(resv && resv.period) {
          if(resv.days > 0)
            price *= resv.days;
        }
        return price;
      },
      discountPrice() {
        let resv = this.selectedResv;
        let discount_price = 0;
        let has_discount = false;
        // 할인 있을 경우 반영
        if(this.product.price.is_discount) {
          // 시간대 할인
          if(this.product.price.discount_period_type) {
            let start_time = resv.start_time;
            let end_time = resv.end_time;
            let discounts = this.product.price.discount_time.filter(item => {
              return item.start_time === start_time && item.end_time === end_time;
            }).length;
            if(discounts>0) {
              has_discount = true;
            }
          }
          // 날짜별 할인
          else {
            let resv_date = resv.org_start_date;
            if(!resv_date) {
              resv_date = resv.resv_date;
            }
            let start_date = this.product.price.start_date;
            let end_date = this.product.price.end_date;

            if(this.moment(start_date).isBefore(resv_date) && this.moment(end_date).isAfter(resv_date)) {
              has_discount = true;
            }
          }

          if(has_discount) {
            // 할인율 적용
            if(this.product.price.discount_type === 0) {
              discount_price = this.product.price.price * (this.product.price.discount_rate/100);
            }
            // 할인금액 적용
            else {
              discount_price = this.product.price.discount_price;
            }
          }
        }
        return discount_price;
      },
      inputStyle() {
        return {
          backgroundColor: '#ffffff',
          padding: '16px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }
      },
      inputDateStyle() {
        return {
          backgroundColor: '#ffffff',
          padding: '12px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }
      },
      optQuantityStyle() {
        return {
          backgroundColor: '#ffffff',
          padding: '16px',
          borderRadius: '4px',
          border: '1px solid #ddd'
        }
      },
      numberStyle() {
        return {
          backgroundColor: '#ffffff',
          padding: '2px 16px',
          borderRadius: '4px'
        }
      },
      dateText() {
        let text = '일정을 선택해주세요.'
        if(this.selectedResv) {
          let resv = this.selectedResv;
          if(resv.period) {
            let start_date = this.datesFormat(resv.resv_date, 'date_5');
            let end_date = this.datesFormat(resv.resv_end_date, 'date_5');
            text = start_date === end_date ? start_date : `${start_date} ~ ${end_date}`;
          } else {
            text = this.datesFormat(resv.org_start_date, 'date_5');
          }
        }

        return text;
      },
      timeText() {
        let text = '';
        if(this.selectedResv) {
          let resv = this.selectedResv;
          if(!resv.period) {
            if(resv.all_time) {
              text = '종일';
            } else {
              text = `${resv.start_time} ~ ${resv.end_time}`;
            }
          }
        }
        return text;
      },
      optionDropdownStyle() {
        return {
          container: {
            margin: '0 0 8px 0'
          },
          dropdown: {
            backgroundColor: '#ffffff',
            color: '#333333',
            height: '48px',
            padding: '16px',
            fontSize: '14px',
            borderRadius: '4px'
          },
          dropList: {
            top: '50px',
            borderRadius: '4px',
            padding: '8px 0'
          },
          dropItem: {
            backgroundColor: '#ffffff',
            color: '#333333',
            padding: '8px 16px'
          }
        }
      },
      closeStyle() {
        return {
          borderRadius: '4px',
          width: '24px',
          height: '24px',
          lineHeight: '24px',
          backgroundColor: '#F45853',
          color: 'white',
          textAlign: 'center',
          marginLeft: '8px',
          fontSize: '18px'
        }
      }
    },
    watch: {

    }
  }
</script>
<style lang="stylus" scoped>
  .color-main
    color #333333
  .color-sub
    color #989898
  .size-12
    font-size 12px
  .size-14
    font-size 14px
  .size-16
    font-size 16px
</style>

